import { render } from "./Outputs.vue?vue&type=template&id=23b873ac"
import script from "./Outputs.vue?vue&type=script&lang=js"
export * from "./Outputs.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__